import { render } from "./standings-desktop.vue?vue&type=template&id=dbf912ce&scoped=true"
import script from "./standings-desktop.vue?vue&type=script&lang=js"
export * from "./standings-desktop.vue?vue&type=script&lang=js"

import "./standings-desktop.vue?vue&type=style&index=0&id=dbf912ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbf912ce"]])

export default __exports__